import * as React from "react";
import styles from "./Header.module.scss";

export const Header: React.FC = () => (
  <div className={styles.header}>
    <h1>Vessel master database</h1>
  </div>
);
